<div class="block page_block_inner">
    <div classs="row">
        <ejs-chart id="chart-container" [primaryXAxis]='primaryXAxis' [primaryYAxis]='primaryYAxis' [legendSettings]='legendSettings' [title]='title'  [tooltip]='tooltip' >
            <e-series-collection>
                <e-series [dataSource]='chartData' type='Line' xName='xVal' yName='yVal' name='Referals Registered' [marker]='marker'></e-series>
            </e-series-collection>
        </ejs-chart>
    </div>
</div>